module.exports = __webpack_public_path__ + "img/fugai.7b594e23.png";